import './style.css';
import React from 'react';
import propTypes from 'prop-types';
import Poi from './Poi';
import { getOneNew } from '../../store/actions/poi';
import { connect } from 'react-redux';
import { parseQuery } from '../../utils/url';
import * as selector from './selector';
import InitScreen from '../../components/InitScreen';

const query = parseQuery();

class InitPoi extends React.Component {
  static propTypes = {
    initStatus: propTypes.string,
    poi: propTypes.object,
    city: propTypes.object,
    onAdd: propTypes.func,
    onRemove: propTypes.func
  };

  render() {
    return (
      <InitScreen
        {...this.props}
        loadImage={query.tab === 'comments' ? 'commentsLoadImage.svg' : 'poiLoadImage.svg'}
        status={this.props.initStatus}
        component={Poi} />
    );
  }

  componentDidMount() {
    let { getOneNew } = this.props;
    getOneNew(query.poi_uid);
  }
}

const PoiContainerConnect = connect(function (state, ownProps) {
  let poi = selector.poi(state, query.poi_uid);
  let city = (poi && poi.city_info) || {};
  let videos = selector.videos(state);
  let nextStation = selector.nextStations(state);
  let initStatus = selector.initStatus(state, poi);
  return {
    ...ownProps,
    poi, city, initStatus, videos, nextStation
  };
},{
  getOneNew
})(InitPoi);

export default PoiContainerConnect;



// WEBPACK FOOTER //
// ./src/components/Poi2/index.js